
import { GameState } from '../GameContextTypes';

export const completeSpecialEvent = (state: GameState): GameState => {
  if (!state.currentSpecialEvent) return state;
  
  let updatedAchievements = [...state.achievements];
  
  // Award achievement for experiencing the special event
  updatedAchievements.push(`Experienced ${state.currentSpecialEvent.title} event`);
  
  return {
    ...state,
    currentSpecialEvent: null,
    achievements: updatedAchievements
  };
};
